import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from '..';

const propTypes = {
  children: PropTypes.node.isRequired,
};

export default function ModalFooter({ children }) {
  return (
    <Flex>
      <Flex.Item marginStart="auto" paddingTop="2em">
        {children}
      </Flex.Item>
    </Flex>
  );
}

ModalFooter.propTypes = propTypes;
